import styled, { css } from 'styled-components';

interface ContainerProps {
  isLastCard?: boolean;
  enabled?: boolean;
  notClickable?: boolean;
  disabled?: boolean;
}

export const Container = styled.div<ContainerProps>`
  height: 292px;
  width: 235px;
  border-radius: 22px;
  border: 1px solid #000;
  background: #fff;
  padding: 20px;
  box-shadow: 4px 4px #000;
  transition: box-shadow 0.08s ease-in-out, transform 0.08s ease-in-out;
  user-select: none;

  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;

  transition: filter 0.2s;

  @media (max-width: 515px) {
    height: 272px;
    width: 195px;
  }

  @media (max-width: 443px) {
    height: 232px;
    width: 155px;
  }

  @media (max-width: 351px) {
    height: 222px;
    width: 165px;
  }

  &:hover {
    filter: ${props => (!props.isLastCard ? '' : 'none')};
  }

  ${props =>
    props.disabled &&
    css`
      * {
        opacity: 50%;
      }
    `}

  ${props =>
    !props.isLastCard &&
    css`
      cursor: pointer;
    `}

  .loading {
    color: #000;
  }

  &:hover,
  &:focus {
    opacity: 0.9;
    outline: 0;
  }

  ${props =>
    !props.notClickable &&
    css`
      &:active {
        box-shadow: none;
        transform: translate3d(4px, 4px, 0px);
      }
    `}

  hr {
    height: 2px;
    width: 100%;
    background-color: #000;
  }
`;

export const PendingQuests = styled.span`
  position: absolute;
  margin-bottom: 124px;
  margin-left: 3px;

  font-size: 16px;
  background: #ff3b01;
  border-radius: 16px;
  padding: 4px 8px;
  color: white;
  font-weight: 500;
  
  @media (max-width: 515px) {
    font-size: 12px;
    margin-bottom: 70px;
  }
`;

export const Logo = styled.img`
  width: 200px;
  max-height: 50px;
  object-fit: contain;

  @media (max-width: 515px) {
    width: 140px;
  }

  @media (max-width: 443px) {
    width: 132px;
  }

  @media (max-width: 351px) {
    width: 96px;
  }
`;

export const Amount = styled.b`
  font-size: 24px;
  font-weight: 700;

  color: black;

  @media (max-width: 515px) {
    font-size: 24px;
  }

  @media (max-width: 443px) {
    font-size: 20px;
  }

  @media (max-width: 351px) {
    font-size: 16px;
  }
`;

export const AmountUnit = styled.span`
  font-size: 16px;
  font-weight: 400;
`;

export const ActionText = styled.h1`

  text-align: left;

  font-size: 20px;

  @media (max-width: 515px) {
    font-size: 16px;
  }

  @media (max-width: 443px) {
    font-size: 12px;
  }

  @media (max-width: 351px) {
    font-size: 12px;
  }
`;

export const EarningInfoIcon = styled.img`
  width: 40px;
  height: 40px;

  @media (max-width: 515px) {
    width: 32px;
    height: 32px;
  }

  @media (max-width: 443px) {
    width: 24px;
    height: 24px;
  }

  @media (max-width: 351px) {
    width: 16px;
    height: 16px;
  }
`;

export const Divider = styled.div`
  height: 100%;
  width: 1px;
  margin: 0 12px;
  background: #ababab;

  @media (max-width: 769px) {
    display: none;
  }
`;

export const EarningInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const Description = styled.span`

  font-size: 16px;

  @media (max-width: 515px) {
    font-size: 12px;
  }

  font-family: ${props => props.theme.font.default};
  color: #222222;
  text-align: left;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const VerticalContainer = styled(Container)`
  flex-direction: row!important;
  justify-content: space-between;
  height: 160px!important;
  width: 100%!important;
  border-radius: 10px;
  padding: 0px;

  align-items: center;

  @media (max-width: 515px) {
    height: 100px!important;
  }

  ${ActionText} {
    font-size: 18px;
    line-height: 24px;
  }

  ${Description} {
    text-align: start;
  }

  ${Logo} {
    border-radius: 10px;
    border: solid 1px black;

    min-width: 140px;
    max-width: 140px;
    min-height: 140px;
    max-height: 140px;

    margin-left: 10px;

    @media (max-width: 515px) {
      min-width: 80px;
      max-width: 80px;
      min-height: 80px;
      max-height: 80px;

      margin-left: 10px;
    }
  }
`;

export const LargeContainer = styled(Container)`
  height: 360px;
  min-width: 270px;
  align-items: center;
  justify-content: space-between;
  padding: 0;

  .logo-wrapper {
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-bottom: solid 1px black;
    border-bottom-left-radius: 22px;
    border-bottom-right-radius: 22px;
    padding: 20px;
  }

  @media (max-width: 515px) {
    height: 340px;
    min-width: 250px;

    .logo-wrapper {
      height: 170px;
    }
  }

  @media (max-width: 443px) {
    height: 310px;
    min-width: 220px;

    .logo-wrapper {
      height: 155px;
    }
  }

  @media (max-width: 351px) {
    height: 280px;
    min-width: 190px;

    .logo-wrapper {
      height: 140px;
    }
  }

  ${Logo} {
    width: 100%;
  }

  ${Description}, ${EarningInfo} {
    padding: 20px;
    width: 100%;
  }
`;
